
























































































import {
  Component,
  Vue
} from 'vue-property-decorator'
import axios from 'axios'
@Component
export default class ContactCovid extends Vue {
    name = ''
    email = ''
    phone = ''
    checkbox = false

    submited = false

    errorNameVisibility = false
    errorEmailVisibility = false
    errorPhoneVisibility = false
    errorCheckboxVisibility = false

    checkValidity () {
      this.errorNameVisibility = !(/^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/u).test(this.name)
      this.errorPhoneVisibility = !(/^((\+\d{2,4})|(0)|(00\d{2}))([1-9])(\d{2}){4}$/).test(this.phone)
      if (this.email.length > 0) this.errorEmailVisibility = !(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/).test(this.email)
      else this.errorEmailVisibility = false
      this.errorCheckboxVisibility = !this.checkbox

      if (!this.errorEmailVisibility && !this.errorPhoneVisibility && !this.errorNameVisibility && this.checkbox) {
        axios
          .post(`https://${process.env.VUE_APP_API_URL}/api_click_and_collect/v7/covid_contact`, {
            fullname: this.name,
            phone: this.phone,
            email: this.email
          }, {
            params: {
              restaurant_token: this.$route.params.restaurant_token //eslint-disable-line
            }
          })
          .then((response) => {
            // console.log(response)
            const link = response.data.link
            this.$router.replace({ name: 'Thank', params: { link }  }) //eslint-disable-line
          })
          .catch(function (error) {
            console.log(error)
          })
      }
    }
}
